import loadSflyAuth from '@sfly/uig-cdn-libraries/dist/loadSflyAuth';
import Logger from './Logger';
const SIGNUP_CONFIRMATION = 'SIGNUP_CONFIRMATION_PAGE';
const loggerInstance = new Logger('SFLYAuth',SIGNUP_CONFIRMATION);

export default class SFLYAuth {
    static async authenticate() {
        try {
            if (!window.$sflyAuth) {
                const initAuth = await loadSflyAuth();
                await initAuth();
            }

            const { jwtToken } = await window.$sflyAuth.getIdToken();
            if (jwtToken) {
                return {
                    type: 'AUTHENTICATION_SUCCESS',
                };
            } else {
                return {
                    type: 'AUTHENTICATION_FAILURE',
                    error: {
                        message:
                            'Error: Something went wrong while fetching token',
                    },
                };
            }
        } catch (e) {
            return {
                type: 'AUTHENTICATION_FAILURE',
                error: e.error || e,
            };
        }
    }

    static redirectToSignUp(error) {
        loggerInstance.error(error.message, 'redirectToSignUp', error, null, {
            time: new Date(),
        });
        return (
            window.$sflyAuth &&
            window.$sflyAuth.showSignUp({
                brand: 'SFLY',
            })
        );
    }
}
